module.exports = __webpack_public_path__ + "img/8.477fc54e.png";